<template>
  <div class="container">
    <home-title
      title="学习专题"
      link2="/learn/subject"
      :icon="require('@/assets/images/home/home_title/icon5.svg')"
      titleMarginBottom="0"
      :newWindow="true"
    ></home-title>
    <div class="subject_box">
      <div class="me-list">
        <swiper ref="teamSwiper" :options="teamOptions">
          <swiper-slide v-for="e in subjectData" :key="e.album_id">
            <div class="banner_box ta3">
              <a
                :href="e.subject_link"
                class="banner_link"
                :style="`background:url(${$prefixSrc(
                  e.subject_cover
                )}) no-repeat`"
                target="_blank"
              >
                <div class="subject_bottom">
                  <div class="subject_title toh2">
                    {{ e.subject_name }}
                  </div>
                </div>
              </a>
            </div>
          </swiper-slide>
        </swiper>
        <div class="swiper-button-prev arrows"></div>
        <div class="swiper-button-next arrows"></div>
      </div>
    </div>
  </div>
</template>

<script>
import homeTitle from "./components/homeTitle";
import { getIndexSubject } from "@/api/home";
export default {
  name: "studySubject",
  components: { homeTitle },
  data() {
    return {
      teamOptions: {
        slidesPerView: "auto",
        loop: true,
        loopAdditionalSlides: 3,
        loopedSlides: 6,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      listQuery: {
        page: 1,
        limit: 1000,
      },
      subjectData: [],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      getIndexSubject(this.listQuery).then((res) => {
        this.subjectData = res.data.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding-top: 50px;
  .subject_box {
    width: 100%;
    .me-list {
      position: relative;
      .swiper-container {
        width: 1420px;
        height: 100%;
        position: relative;
        padding: 24px 20px 30px;
        margin-left: -20px;
        .swiper-slide {
          font-size: 18px;
          display: flex;
          justify-content: center;
          align-items: center;
          transition: 300ms;
          margin-right: 0;
          width: 327px;
          height: 200px;
          padding-right: 24px;
        }
        .banner_box {
          width: 100%;
          height: 100%;
          background: #b2b2b2;
          border-radius: 10px;
          box-sizing: border-box;
          cursor: pointer;
          overflow: hidden;
          &:hover {
            -moz-transform: translateY(-10px);
            -webkit-transform: translateY(-10px);
            -o-transform: translateY(-10px);
            -ms-transform: translateY(-10px);
            transform: translateY(-10px);
            box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.16);
          }
          .banner_link {
            width: 100%;
            height: 100%;
            display: inline-block;
            position: relative;
            background-size: cover !important;
            background-position: center center !important;
            .subject_bottom {
              position: absolute;
              left: 0;
              bottom: 0;
              width: 100%;
              height: 76px;
              background: linear-gradient(
                360deg,
                #333 0%,
                rgba(255, 255, 255, 0) 100%
              );
              display: flex;
              justify-content: center;
              flex-direction: column;
              border-radius: 0 0 10px 10px;
              padding: 0 20px;

              .subject_title {
                font-size: 14px;
                font-weight: 600;
                line-height: 20px;
                color: #ffffff;
              }
            }
          }
        }
      }
      --swiper-theme-color: #b2b2b2;
      --swiper-navigation-size: 23px;
      .swiper-button-next {
        right: -21px;
      }
      .swiper-button-prev {
        left: -21px;
      }
      .swiper-button-disabled {
        display: none;
      }
      .arrows {
        width: 44px;
        height: 44px;
        font-weight: 700;
        transform: translate(-0%, -33%);
        transition: all 0.35s;
        background: rgba(255, 255, 255, 0.8);
        border-radius: 50%;
        border: 1px solid #d8dce6;
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
        &::after {
          font-size: 15px;
        }
      }
    }
  }
}

@media screen and (max-width: 1500px) and (min-width: 270px) {
  .container {
    .subject_box {
      .me-list {
        .swiper-container {
          width: 1140px;
          .swiper-slide {
            width: 260px;
            height: 159px;
            padding-right: 20px;
          }
          .banner_box {
            .banner_link {
              .subject_bottom {
                height: 60px;
                padding: 0 16px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
